import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loadUser } = useAuth();

  useEffect(() => {
    const accessToken = searchParams.get('access_token');
    const refreshToken = searchParams.get('refresh_token');

    if (accessToken && refreshToken) {
      localStorage.setItem('access_token', accessToken);
      localStorage.setItem('refresh_token', refreshToken);
      loadUser().then(async () => {
        try {
          const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/preferences/`, {
            headers: { 'Authorization': `Bearer ${accessToken}` },
          });
          const prefs = res.ok ? await res.json() : null;
          if (prefs && prefs.roles && prefs.roles.length > 0) {
            navigate('/dashboard', { replace: true });
          } else {
            navigate('/onboarding', { replace: true });
          }
        } catch {
          navigate('/onboarding', { replace: true });
        }
      });
    } else {
      navigate('/login', { replace: true });
    }
  }, [searchParams, navigate, loadUser]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#F9FAFB',
      fontSize: '18px',
      color: '#374151',
    }}>
      Signing you in...
    </div>
  );
}

export default OAuthCallback;
